<script lang="ts" setup>
	import type {HTMLAttributes} from 'vue';
	import {cn} from '@/scripts/utils/utils';
	import {Primitive, type PrimitiveProps} from 'radix-vue';
	import {type ButtonVariants, buttonVariants} from '.';

	interface Props extends PrimitiveProps {
		variant?: ButtonVariants['variant'];
		size?: ButtonVariants['size'];
		class?: HTMLAttributes['class'];
	}

	const props = withDefaults(defineProps<Props>(), {
		as: 'button',
	});
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="cn(buttonVariants({variant, size}), props.class)"
	>
		<slot />
	</Primitive>
</template>
